import styled from 'styled-components';

export const ContainerSchedule = styled.div<{ isSimulator: boolean }>`
  height: 944px;
  pointer-events: auto;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: ${({ isSimulator }) => (isSimulator ? '64px' : '0px')};
`;

export const CourseTitle = styled.div`
  text-align: start;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #161d1f;
`;

export const CourseData = styled.div`
  display: flex;
  width: 304px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #161d1f;
  gap: 8px;
`;

export const SubCourseData = styled.div`
  width: 148px;
  white-space: nowrap;
  height: 20px;
  padding: 0px 29px 0px 0px;
`;

export const TextSchedule = styled.div<{ isSection?: boolean }>`
  width: Fill (324px);
  height: Hug (36px);
  padding: ${({ isSection }) =>
    isSection ? '12px 12px 4px 12px' : '4px 12px 4px 12px'};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #161d1f;
`;
